import { render, staticRenderFns } from "./ReportHeading.vue?vue&type=template&id=ef053a40"
import script from "./ReportHeading.vue?vue&type=script&lang=js"
export * from "./ReportHeading.vue?vue&type=script&lang=js"
import style0 from "./ReportHeading.vue?vue&type=style&index=0&id=ef053a40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports